<template>
    <header>
        <router-link :to="{name: 'home-with-lang', params:{ lang }}" class="btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 65"><path fill-rule="evenodd" d="M55.07 61.72c-.26 1.11-5.36 4.04-12.45 1.77-3.32-1.07-1.21-11.6-2.7-13.5-1.16-1.48-11.14-3.17-14.39.1-2.03 2.04.06 12.43-4.3 13.7-6.45 1.87-7.8.24-8.79-.05-1.89-.54-4.05-.8-3.86-12.14.18-11.3 1.3-19.76 1.3-19.76s-4.36 3.08-7.34 2.54c-2.97-.54-4.34-2.61 1.6-12.33C10.09 12.31 30.62-1.94 34.41.22c5.21 2.97 15.44 8.87 25.27 22.58 4.65 6.48 6.39 14.69-1.81 11.02-3.74-1.68-3.64-1.96-3.64-1.96s2.22 24.04.84 29.87v-.01Z" clip-rule="evenodd"/></svg>
            <span class="sr-only">Accueil</span>
        </router-link>
    </header>

    <div class="page-box settings">
        <div class="box">
            <router-link :to="previousPage" class="icon-close">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 43 43"><path d="M29.07 22 41.46 9.61a5.003 5.003 0 0 0 0-7.07 5.003 5.003 0 0 0-7.07 0L22 14.93 9.54 2.46a5.016 5.016 0 0 0-7.08 0 5.016 5.016 0 0 0 0 7.08L14.92 22 2.57 34.36a5.003 5.003 0 0 0 0 7.07 5.003 5.003 0 0 0 7.07 0L22 29.07l12.28 12.28a5.003 5.003 0 0 0 7.07 0 5.003 5.003 0 0 0 0-7.07L29.07 22Z"/></svg>
            </router-link>

            <RangeSlider min="0" max="100" step="1" label="Volume de la musique" />
            <RangeSlider min="0" max="100" step="1" label="Volume des effets" />
            <RangeSlider min="0" max="100" step="1" label="Volume de la narration" />
        </div>
    </div>
</template>

<script>
    import RangeSlider from "../components/RangeSlider";

    export default {
        name: "Settings",
        components: {RangeSlider}
    }
</script>

<script setup>
    import { computed } from "vue";

    import { useMainStore }     from "../stores/main";
    import { storeToRefs }        from "pinia";

    let store = useMainStore();
    const { lang } = storeToRefs(store);

    let { getPreviousPage } = store;
    let previousPage = computed ( () => getPreviousPage());

</script>
